<template>
  <v-dialog scrollable max-width="850px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn x-small color="secondary" dark v-on="on" @click="init">
        Eliminar detalle
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h4>Eliminar Detalle</h4>
      </v-card-title>
      <v-card-text>

        <v-data-table dense :items="items" :headers="headers">
          <template v-slot:[`item.actions`]="props">
            <v-btn
              small
              color="primary"
              @click="confirmar(props.item)"
              :loading="loading"
              >Eliminar</v-btn
            >
          </template>
        </v-data-table>
        <v-textarea
              auto-grow
              rows="1"
              type="text"
              label="Observacion"
              v-model="observacion"
              hint="Ingrese la descripcion del motivo del cambio"
            />
      </v-card-text>
      <div class="red--text" v-if="errorMessage">{{ errorMessage }}</div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["texto", "op"],
  components: {},
  data() {
    return {
      loading: false,
      showDialog: false,
      errorMessage: "",
      asignacionId: null,
      observacion: '',
      items: [],
      monto: "",
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
      headers: [
        { text: "id", value: "id" },
        { text: "Nombre", value: "nombre" },
        { text: "Tipo", value: "tipo" },
        { text: "Monto", value: "monto" },
        { text: "", value: "actions" },
      ],
    };
  },
  mounted() {},
  methods: {
    init() {
      this.errorMessage = "";
      this.asignacionId = null;
      this.monto = "";
      axios
        .get("liquidacion/getLiquidacionEdit/" + this.op.id)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => console.log(err));
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar(item) {
      if (!confirm("desera eliminar este detalle?")) return;

      console.log(item);

      this.loading = true;
      axios
        .post("/liquidacion/eliminarDetalle", {
          tipo: item.tipo,
          id: item.id,
          observacion: this.observacion
        })
        .then((response) => {
          console.log(response);
          // this.$emit("nuevaCedula", {
          //   id: this.id,
          //   nuevaCedula: this.nuevaCedula,
          // });
          this.$emit("refresh");
          this.init();
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

      // this.$emit("detalleAgregado", {});
      // this.close();
    },
    setAsignacionId(id) {
      this.asignacionId = id;
    },
  },
});
</script>